import { render, staticRenderFns } from "./ExchangeModal.vue?vue&type=template&id=15476cdb&"
import script from "./ExchangeModal.vue?vue&type=script&lang=js&"
export * from "./ExchangeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports